import clsx from 'clsx'
import classes from './Example.module.scss'

export default function Example() {
  return (
    <div className={classes.tableWrap}>
      <table className={classes.table}>
        <thead>
          <tr>
            <th>Customer</th>
            <th>Status</th>
            <th>Rate</th>
            <th>Balance</th>
            <th>Deposit</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div className={classes.table__text}>Ralph Edwards</div>
              <span className={classes.table__caption}>(405) 555-0128</span>
            </td>
            <td>
              <span className={classes.status}>Open</span>
            </td>
            <td>
              <div className={classes.table__text}>$78.00</div>
              <span className={classes.table__caption}>USD</span>
            </td>
            <td>
              <div
                className={clsx(classes.table__text, classes.table__textRed)}
              >
                -$105.55
              </div>
              <span className={classes.table__caption}>USD</span>
            </td>
            <td>
              <div className={classes.table__text}>$293.01</div>
              <span className={classes.table__caption}>USD</span>
            </td>
          </tr>
          <tr>
            <td>
              <div className={classes.table__text}>Floyd Miles</div>
              <span className={classes.table__caption}>(480) 555-0103</span>
            </td>
            <td>
              <span className={clsx(classes.status, classes.statusPaid)}>
                Paid
              </span>
            </td>
            <td>
              <div className={classes.table__text}>$40.00</div>
              <span className={classes.table__caption}>USD</span>
            </td>
            <td>
              <div
                className={clsx(classes.table__text, classes.table__textGreen)}
              >
                $275.43
              </div>
              <span className={classes.table__caption}>USD</span>
            </td>
            <td>
              <div className={classes.table__text}>$710.68</div>
              <span className={classes.table__caption}>USD</span>
            </td>
          </tr>
          <tr>
            <td>
              <div className={classes.table__text}>Floyd Miles</div>
              <span className={classes.table__caption}>(480) 555-0103</span>
            </td>
            <td>
              <span className={clsx(classes.status, classes.statusInactive)}>
                Inactive
              </span>
            </td>
            <td>
              <div className={classes.table__text}>$85.00</div>
              <span className={classes.table__caption}>USD</span>
            </td>
            <td>
              <div
                className={clsx(classes.table__text, classes.table__textGreen)}
              >
                $928.41
              </div>
              <span className={classes.table__caption}>USD</span>
            </td>
            <td>
              <div className={classes.table__text}>$779.58</div>
              <span className={classes.table__caption}>USD</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}
